<script lang="ts" setup>
import { useEditorStore } from '@/stores/Editor'
import { rules } from '@/helpers/rules'

import PlusIcon from '@/components/icons/PlusIcon.vue'
import TrashIcon from '@/components/icons/TrashIcon.vue'

const editorStore = useEditorStore()
const items = defineModel<string[]>({ default: () => [] })

const addItem = () => {
  items.value.push('')
}

const removeItem = (index: number) => {
  items.value.splice(index, 1)
}
</script>

<template>
  <div class="mb-5">
    <div v-for="(item, index) in items" :key="index" class="d-flex mb-3">
      <v-text-field
        v-model="items[index]"
        :disabled="editorStore.publishLoading"
        :rules="[rules.maxlength(), rules.required]"
        autofocus
        flat
        variant="outlined"
      >
        <template v-slot:append-inner>
          <TrashIcon class="btn-remove" @click.prevent="() => removeItem(index)" />
        </template>
      </v-text-field>
    </div>
    <button v-if="items.length < 5" class="btn-add" @click.prevent="addItem">
      <PlusIcon />
    </button>
  </div>
</template>

<style lang="scss" scoped>
.btn-add {
  display: flex;
  width: 100%;
  padding: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  border: 1px solid var(--gray-light-cd);
}

.btn-remove {
  cursor: pointer;
  height: 100%;
}
</style>
